  const env = process.env.REACT_APP_ENV;
  const isProduction = env === 'production';
    

  export const IS_LOGGED_IN = isProduction ? 'isLoggedIn':  `${env}_isLoggedIn`;
  export const API_TOKEN_KEY = isProduction ?  'api_token' : `${env}_api_token`;
  export const REFRESH_TOKEN_KEY = isProduction ?  'refresh_token' : `${env}_refresh_token`;
  export const ID_TOKEN = isProduction ? 'id_token' : `${env}_id_token` ;
  export const TIME_STAMP = isProduction ?  'lastTimeStamp' : `${env}_lastTimeStamp`;
  export const ACCESS_TOKEN_EXPIRY = isProduction ? 'access_token_expiry': `${env}_access_token_expiry` ;
  export const REFRESH_TOKEN_EXPIRY = isProduction ?  'refresh_token_expiry' : `${env}_refresh_token_expiry`;
  export const PERMISSIONSLIST = isProduction ? 'permissionsList' : `${env}_permissionsList`;